<template>
   <v-app id="inspire">
      <VerticalHeader v-model="expandOnHover"></VerticalHeader>

      <v-main>
         <v-container fluid class="page-wrapper">
            <slot></slot>
         </v-container>
      </v-main>

      <VerticalSidebar :expand-on-hover.sync="expandOnHover"></VerticalSidebar>

      <Footer></Footer>

      <!-- Modal Portal -->
      <portal-target name="modal" multiple></portal-target>
   </v-app>
</template>

<script>
import VerticalHeader from "./vertical-header/VerticalHeader";
import VerticalSidebar from "./vertical-sidebar/VerticalSidebar";
import Footer from "./footer/Footer";

export default {
   name: "DashboardLayout",

   components: {
      VerticalHeader,
      VerticalSidebar,
      Footer,
   },

   props: {
      source: String,
   },

   data: () => ({
      expandOnHover: false,
   }),
};
</script>

<style>
</style>